import * as React from 'react';

function SvgFloppy(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" focusable={false} role="presentation" aria-hidden={true} {...props}>
      <path d="M19.76 0H3a3 3 0 00-3 3v18a3 3 0 003 3h18a3 3 0 003-3V4.69zM18 9a1.5 1.5 0 01-1.5 1.5h-9A1.5 1.5 0 016 9V1.5h12zm-1.5-6h-3v6h3z" />
    </svg>
  );
}

const MemoSvgFloppy = React.memo(SvgFloppy);
export default MemoSvgFloppy;
